// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"a3a3e746","280":"4b7fffd4","860":"022901fe","913":"2f406fdb"}[chunkId] + ".chunk.css";
};